import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag,
    InputNumber
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    deleteTemplateAirPrint, addTemplateAirPrint, getTemplateAirPrint
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentAirPrint = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {
        getTemplateAirPrint(templateId).then((res) => {
            if (res && res != null && res.ipAddress) {
                setShowTable(2)
                setIsAdd(false);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
                setIsAdd(true);
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var req = {} as any;
                console.log(res);
                addTemplateAirPrint(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            deleteTemplateAirPrint(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        })

    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("隔空打印")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置隔空打印")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 14 }}
                            initialValues={{ backupAllVolumes: false,backupSkipSys: true, autoBackup: false,
                                mobileBackups: false, backupSizeMB: 0, basePaths: [], skipPaths: []
                              }}
                        >
                            <Item
                                label={t("主机名/IP地址")}
                                name="ipAddress"
                                rules={[{ required: true }]}
                            >
                                <Input></Input>
                            </Item>                                                   
                            <Item
                                label={t("端口号")}
                                name="port"
                            >
                                <InputNumber max={65535} min={0}></InputNumber>
                            </Item>
                            <Item
                                label={t("资源路径")}
                                name="resourcePath"
                                rules={[{ required: true }]}
                                extra={t("如 ipp/print")}
                            >
                                <Input></Input>
                            </Item>
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};